import { ApplicationConfig } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { authResponseInterceptor } from './core/auth/auth-response.interceptor';
import { apiCredentialsInterceptor } from './core/http/api-credentials.interceptor';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([apiCredentialsInterceptor, authResponseInterceptor])),
    provideRouter(routes),
    provideAnimationsAsync(),
  ],
};
